import { render, staticRenderFns } from "./adjustment-quantity-details.vue?vue&type=template&id=6b53880a&scoped=true"
import script from "./adjustment-quantity-details.vue?vue&type=script&lang=js"
export * from "./adjustment-quantity-details.vue?vue&type=script&lang=js"
import style0 from "./adjustment-quantity-details.vue?vue&type=style&index=0&id=6b53880a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b53880a",
  null
  
)

export default component.exports